// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"kda-z","narrowOptionButtons":"lda-z","noOptions":"mda-z"};